var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',_vm._l((_vm.sortedAllocations),function(allocation){return _c('tr',{key:allocation.id,attrs:{"allocation":allocation}},[_c('td',[_vm._v(_vm._s(allocation.category))]),_c('td',[_vm._v(_vm._s(allocation.quantityLabel))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }